module.exports = __webpack_public_path__ + "static/img/teBuContent4.f16f1f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teBuContent4.png
// module id = xC9k
// module chunks = 2